'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('contact-list', {
      url: '/contact/list',
      template: '<contact-list></contact-list>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/contact-list/contact-list.routes.js